module.exports = __webpack_public_path__ + "img/stepan-butko.35e2e998.jpg";